import { useQuery } from "@tanstack/react-query"
import type { CustomersResponse } from "@/shared/api/types/CustomersResponse"
import type { GetCustomersParameters } from "@/shared/api/types/GetCustomerParameters"
import { useCmApi } from "@/shared/hooks/useCmApi"

const QUERY_KEY = "customers"

export const useGetCustomers = (params: GetCustomersParameters) => {
  const cmApi = useCmApi()

  return useQuery<CustomersResponse>({
    queryKey: [QUERY_KEY, params],
    queryFn: () =>
      cmApi.getCustomers({
        page: params.page,
        pageSize: params.pageSize,
        searchTerm: params.searchTerm,
        sortBy: params.sortBy,
        sortOrder: params.sortOrder,
        sdmEmail: params.sdmEmail,
        salesforceId: params.salesforceId,
        relationshipType: params.relationshipType,
        relationshipSubType: params.relationshipSubType
      }),
    placeholderData: (prev?: CustomersResponse) => prev,
    enabled: params.enabled
  })
}
